<!-- ── Default View ────────────────────────────────────────────── -->
<div class="row mb-3px">
  <div class="col wccard pt-3 pb-3">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-start mb-4">
      <div>
        <p class="f-14 font-weight-600 mb-1">Email Sending Limits</p>
        <p class="f-12 gray-text mb-0">
          Sending limits protects your mailbox reputation. Control how many emails your campaigns send per hour and per day to protect mailbox reputation.
        </p>
      </div>
      <button data-testid="auto-app-campaigns-limits-button-1" type="button" class="btn btn-outline-secondary btn-sm cl-edit-btn flex-shrink-0" (click)="openEditModal()">
        Edit
      </button>
    </div>

    <!-- Selected level badge -->
    <div class="d-flex align-items-center mb-4">
      <span class="f-12 gray-text mr-2">Selected Safety Level:</span>
      <span class="cl-badge cl-badge--{{ activeLevelKey }}">{{ activeLevelLabel }}</span>
    </div>

    <!-- Stats -->
    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <div class="cl-stat-card">
          <p class="cl-stat-value">{{ activeDailyDisplay }}</p>
          <p class="cl-stat-label">Emails per Day</p>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="cl-stat-card">
          <p class="cl-stat-value">{{ activeHourlyDisplay }}</p>
          <p class="cl-stat-label">Emails per Hour</p>
        </div>
      </div>
    </div>

    <!-- Level note -->
    <p class="f-12 gray-text mb-2">{{ activeLevelNote }}</p>
    <p class="f-12 gray-text mb-0">
      Emails exceeding limits are automatically queued and sent when capacity becomes available.
    </p>

  </div>
</div>

<!-- ── Save confirmation bar ──────────────────────────────────── -->
<div *ngIf="infoBarVisible" class="row mt-2">
  <div class="col-12">
    <div class="alert alert-info d-flex justify-content-between align-items-center" role="alert">
      <div>
        <p class="mb-0 font-weight-600">Settings saved</p>
        <p class="mb-0 f-12 gray-text">Your sending limits were updated and will be enforced. Queued emails will resume automatically.</p>
      </div>
    </div>
  </div>
</div>

<!-- ── Edit Modal ─────────────────────────────────────────────── -->
<div *ngIf="editModalOpen" class="cl-modal-overlay" (click)="onOverlayClick($event)">
  <div class="cl-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="clModalTitle">

    <!-- Modal header -->
    <div class="cl-modal-header">
      <p class="f-14 font-weight-600 mb-0" id="clModalTitle">Configure Email Sending Limits</p>
      <button data-testid="auto-app-campaigns-limits-button-2" class="cl-btn-close" (click)="closeEditModal()" aria-label="Close">&#x2715;</button>
    </div>

    <!-- Modal body -->
    <div class="cl-modal-body">
      <table class="cl-level-table w-100">
        <thead>
          <tr>
            <th>Level</th>
            <th>Emails&nbsp;/&nbsp;Day</th>
            <th>Emails&nbsp;/&nbsp;Hour</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let lvl of levelConfig; let i = index"
            class="cl-level-row"
            [class.cl-level-row--selected]="pendingLevel === i"
            (click)="pendingLevel = i"
          >
            <td>
              <div class="d-flex align-items-center">
                <span class="cl-radio mr-2" [class.cl-radio--checked]="pendingLevel === i"></span>
                <span class="cl-badge cl-badge--{{ lvl.key }}">{{ lvl.label }}</span>
                <span *ngIf="i === 0" class="f-12 gray-text ml-2">(Default)</span>
              </div>
            </td>
            <td class="f-12 font-weight-600">{{ lvl.daily }}</td>
            <td class="f-12 font-weight-600">{{ lvl.hourly }}</td>
            <td class="f-12 gray-text">{{ lvl.note }}</td>
          </tr>
        </tbody>
      </table>

      <p class="f-12 gray-text mt-3 mb-0">
        Emails exceeding limits are automatically queued and sent when capacity becomes available.
      </p>
    </div>

    <!-- Modal footer -->
    <div class="cl-modal-footer">
      <button data-testid="auto-app-campaigns-limits-button-3" class="btn btn-light btn-sm mr-2" (click)="closeEditModal()">Cancel</button>
      <button data-testid="auto-app-campaigns-limits-button-4" class="btn btn-primary btn-sm" (click)="saveFromModal()">Save changes</button>
    </div>

  </div>
</div>
